import React from 'react';
import { Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { emojiBooksSvg, emojiBookSvg, emojiClockSvg } from '../../assets/images';
import { SITE_LINKS } from '../../constants';
import { Background } from '../../stories/Background';
import { Button } from '../../stories/Button';
import { Header } from '../../stories/Header';
import { OnboardingNavbar } from '../../stories/OnboardingNavbar';

export const OnboardingRecommendationsPage: React.FC = () => {
  const __ = useTranslation().t;

  return (
    <>
      <Header type="logo-only" />
      <Background>
        <Container>
          <div className="oejr-page-onboarding oejr-page-onboarding-2">
            <OnboardingNavbar
              numberOfCompletedSteps={0}
              totalSteps={3}
              title={__('followTheseRecommendations')}
            />
            <h1 className="oejr-onboarding-main-argument">{__('usefulTips')}</h1>
            <div className="oejr-onboarding-argument-cards-wrapper">
              <div className="oejr-onboarding-argument-card">
                <h1>
                  <img src={emojiClockSvg} alt="Emoji Book" />
                </h1>
                <h4>{__('establishingStudyHabitImprovesResults')}</h4>
                <p>{__('havingStudyHabitAccelerateResults')}</p>
              </div>
              <div className="oejr-onboarding-argument-card">
                <h1>
                  <img src={emojiBooksSvg} alt="Emoji Books" />
                </h1>
                <h4>{__('buildStudentsConfidence')}</h4>
                <p>{__('letThemHandleThePlatform')}</p>
              </div>
              <div className="oejr-onboarding-argument-card">
                <h1>
                  <img src={emojiBookSvg} alt="Emoji Book" />
                </h1>
                <h4>{__('takeOrientationSession')}</h4>
                <p>{__('prepareForLiveClassMessage')}</p>
              </div>
            </div>
            <div className="text-center">
              <Button
                icon="arrow-right"
                label={__('continue')}
                variant="primary"
                size="lg"
                href={SITE_LINKS.OnboardingPage(`emergency-contact`)}
              />
            </div>
          </div>
        </Container>
      </Background>
    </>
  );
};
